import { RouteInfo } from "../sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "{{identityUrl}}/Admin/UserList?returnUrl={{returnUrl}}auth/signout-callback",
    title: "User List",
    icon: "ng-tns-c1-0 icon-user-list",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: true,
    submenu: [],
  },
  {
    path: "{{identityUrl}}/Admin/UserApprovalList?returnUrl={{returnUrl}}",
    title: "User Approval",
    icon: "ng-tns-c1-0 icon-user-approval",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: true,
    submenu: [],
  },
  {
    path: "/admin/developers",
    title: "Dev List",
    icon: "icon-dev-list",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "/admin/apps",
    title: "Apps",
    icon: "ng-tns-c1-0 icon-apps",
    class: "",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "/admin/levelplay/adunits",
    title: "LevelPlay",
    icon: "icon-mediation",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "{{spWebUrl}}/Admin/MediationInstances",
        title: "Instances",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: true,
        submenu: [],
      },
      {
        path: "/admin/levelplay/adunits",
        title: "AdUnits",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "/admin/levelplay/operations",
        title: "Operations",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "/admin/levelplay/waterfall-groups",
        title: "Waterfall Groups",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "/admin/levelplay/sync",
        title: "Sync",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/admin/applovin/sync",
    title: "AppLovinMax",
    icon: "icon-max",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "/admin/applovin/sync",
        title: "Sync",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "/admin/applovin/adunits",
        title: "Ad Units",
        icon: "",
        class: "second-level",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },
];
